export const validConfig = config => {
  return config.color && config.files
}

export const createProduct = (id, config, base) => {
  return {
    id,
    name: config.name,
    color: config.color,
    model: base.product.model,
    brand: base.product.brand,
    type: base.product.type.toLowerCase(),
    description: base.product.description,
    images: createImages(config, id),
    variants: createVariants(config, base),
    baseprice: createBasePrice(config, base),
  }
}

export const createImages = (config, id) => {
  return Object.keys(config.files).map(file => {
    return `https://images.tinymerch.com/mockups/${config.userId}/${id}/${file}.jpg`
  })
}

export const createVariants = (config, base) => {
  return base.variants.filter(v => v.color === config.color).map(v => {
    const price = parseFloat(v.price) + parseFloat(config.profit)
    return { ...v, price }
  })
}

export const createBasePrice = (config, base) => {
  return createVariants(config, base).sort((a, b) => a.price - b.price)[0].price
}



// WEBPACK FOOTER //
// ./src/products/list/utils.js